if (!customElements.get('custom-accordion')) {
  customElements.define(
    'custom-accordion',
    class AccordionElement extends HTMLElement {
      constructor() {
        super();
        this.el = this.querySelector('details');
        this.summary = this.el.querySelector('summary');
        this.content = this.el.querySelector('.content');

        //state variables
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        // Event listeners
        this.summary.addEventListener('click', (e) => this.onClick(e));
      }

      onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';

        // If animation is ongoing, return to avoid conflicting animations
        if (this.isClosing || this.isExpanding) return;

        // If the element is closed, we expand it, otherwise we shrink it
        if (!this.el.open) {
          this.toggleAccordion(true);
        } else {
          this.toggleAccordion(false);
        }
      }

      toggleAccordion(expand) {
        // Set the appropriate state for expanding or shrinking
        if (expand) {
          this.isExpanding = true;
        } else {
          this.isClosing = true;
        }

        const startHeight = `${this.el.offsetHeight}px`;

        // If expanding, force the open state to calculate the full height
        if (expand) {
          this.el.open = true;
        }

        // Calculate the end height based on expanding or shrinking
        const endHeight = expand
          ? `${this.summary.offsetHeight + this.content.offsetHeight}px`
          : `${this.summary.offsetHeight}px`;

        // If there's an existing animation, cancel it
        if (this.animation) {
          console.log('check')
          this.animation.cancel();
        }

        // Animate
        this.animation = this.el.animate(
          {
            height: [startHeight, endHeight],
          },
          {
            duration: 350,
            easing: 'ease-in-out',
          }
        );

        // Handle when the animation finishes
        this.animation.onfinish = () => this.onAnimationFinish(expand);
        this.animation.oncancel = () => {
          this.isClosing = this.isExpanding = false; // Reset states if animation is canceled
        };
      }

      onAnimationFinish(expand) {
        // If shrinking, set `open` to false
        if (!expand) {
          this.el.open = false;
        }

        // Reset the animation and state
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;

        // Clear inline styles to reset the layout
        this.el.style.height = '';
        this.el.style.overflow = '';
      }
    }
  );
}